import React, { FC, JSX, PropsWithChildren, useState } from 'react';

import {
  DynamicComponentProps,
  ModalContext,
  ModalContextType,
  ModalProviderProps,
} from '@/shared/contexts';

export const ModalProvider: FC<PropsWithChildren<ModalProviderProps>> = ({
  children,
  components,
}): JSX.Element => {
  const [modalType, setModalType] =
    useState<ModalContextType['modalType']>(null);
  const [modalProps, setModalProps] =
    useState<ModalContextType['modalProps']>(null);

  const hideModal: ModalContextType['hideModal'] = () => {
    setModalType(null);
    setModalProps(null);
  };
  const showModal: ModalContextType['showModal'] = (modalType, modalProps) => {
    setModalType(modalType);
    setModalProps(modalProps || null);
  };
  const DynamicComponent: FC<DynamicComponentProps> = ({ componentName }) => {
    const Component: any = components[componentName];

    if (!Component) return null;

    return <Component {...(modalProps || {})} onClose={hideModal} />;
  };

  return (
    <ModalContext.Provider
      value={{ hideModal, modalProps, modalType, showModal }}>
      {/* eslint-disable-next-line react-hooks/static-components */}
      {modalType && <DynamicComponent componentName={modalType} />}
      {children}
    </ModalContext.Provider>
  );
};
